// extracted by mini-css-extract-plugin
export default {"layout":"CollaboratorsMap_layout__R9hPy","title":"CollaboratorsMap_title__uW4bz","map":"CollaboratorsMap_map__U7ZIz"};